/**
 * Implementation for IFloodgateEnvironmentProvider for web SDK.
 * We pass the SDK's internal locale here and not the one which the host app specifies.
 */
import * as Configuration from "./../Configuration/Configuration";
export default class FloodgateEnvironmentProvider {
  getLanguage() {
    return Configuration.get().getCommonInitOptions().originalLocale;
  }
}